import { render, staticRenderFns } from "./ModalStudentCourses.vue?vue&type=template&id=50e4cf96&scoped=true&lang=pug&"
import script from "./ModalStudentCourses.vue?vue&type=script&lang=ts&"
export * from "./ModalStudentCourses.vue?vue&type=script&lang=ts&"
import style0 from "./ModalStudentCourses.vue?vue&type=style&index=0&id=50e4cf96&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e4cf96",
  null
  
)

export default component.exports